import { useHistory, useLocation } from 'react-router-dom'
import { Button, Navbar } from '@collegebacker/backer-ui/ui'

import { buildPath } from 'routes'

import styles from './GiftingPageHeader.module.scss'
import { useState } from 'react'
import classNames from 'classnames'
import Cookies from 'js-cookie'

const hideCustomizeGiftingPageBannerCookie = 'hideCustomizeGiftingPageBanner'

export const GiftingPageHeader = ({
  handle,
  canUpdateFund
}: {
  handle: string
  canUpdateFund: boolean
}) => {
  const history = useHistory()
  const location: { state?: { previous?: string } } = useLocation()
  const { previous } = location.state || {}

  const [isBannerVisible, setIsBannerVisible] = useState(() =>
    Cookies.get(hideCustomizeGiftingPageBannerCookie) === 'true' ? false : true
  )

  function showEditGiftingPage() {
    history.push({
      pathname: buildPath('editGiftingPage', {
        handle
      }),
      state: {
        previous: 'giftingPage'
      }
    })
  }

  const buttons: Array<{
    label?: string
    icon?: IconTypes
    onClick?: () => void
  }> = canUpdateFund
    ? [
        {
          icon: 'edit',
          label: 'Customize',
          onClick: showEditGiftingPage
        }
      ]
    : []

  return (
    <div className={styles.container}>
      {canUpdateFund && isBannerVisible && (
        <div className={styles.banner}>
          <p className={classNames(styles.bannerText, 'typo-app-body-caption')}>
            This is your gifting page. Customize it and share with family &
            friends.
          </p>
          <Button
            hasMinWidth={false}
            label=""
            icon="cross"
            mode="ghost"
            className={styles.bannerCloseBtn}
            onClick={() => {
              Cookies.set(hideCustomizeGiftingPageBannerCookie, 'true')
              setIsBannerVisible(false)
            }}
            size="small"
          />
        </div>
      )}
      <Navbar
        hideLogo={true}
        backButtonLabel={previous || 'Dashboard'}
        backButtonClick={() => {
          previous ? history.goBack() : history.push(buildPath('dashboard'))
        }}
        backButtonStartColumn={2}
        backButtonClassName={styles.backButton}
        buttons={buttons}
      />
    </div>
  )
}
